
const state = {
	commonPre: 'common', // 通用属性前缀
	commonPreCN: '通用属性', // 通用属性中文前缀
}

const mutations = {
}

export default {
	state,
	mutations
}


// WEBPACK FOOTER //
// ./src/storage/vuex/module/global.js